import { HazardMap } from './types'

export const HazardMaps: HazardMap[] = [
  {
    id: 'shinsuishin',
    label: '洪水浸水想定区域\n(想定最大規模)',
    urls: [
      'https://disaportaldata.gsi.go.jp/raster/01_flood_l2_shinsuishin_data/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '洪水浸水想定区域\n想定浸水深（ｍ）',
        colors: [
          { color: 'rgb(220, 122, 220)', value: '20.0~' },
          { color: 'rgb(242, 133, 201)', value: '10.0~20.0' },
          { color: 'rgb(255, 145, 145)', value: '5.0~10.0' },
          { color: 'rgb(255, 183, 183)', value: '3.0~5.0' },
          { color: 'rgb(255, 216, 192)', value: '0.5~3.0' },
          { color: 'rgb(247, 245, 169)', value: '~0.5' }
        ]
      }
    ]
  },
  {
    id: 'shinsuishin_newlegend',
    label: '洪水浸水想定区域\n(計画規模)',
    urls: [
      'https://disaportaldata.gsi.go.jp/raster/01_flood_l1_shinsuishin_newlegend_data/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '洪水浸水想定区域\n想定浸水深（ｍ）',
        colors: [
          { color: 'rgb(220, 122, 220)', value: '20.0~' },
          { color: 'rgb(242, 133, 201)', value: '10.0~20.0' },
          { color: 'rgb(255, 145, 145)', value: '5.0~10.0' },
          { color: 'rgb(255, 183, 183)', value: '3.0~5.0' },
          { color: 'rgb(255, 216, 192)', value: '0.5~3.0' },
          { color: 'rgb(247, 245, 169)', value: '~0.5' }
        ]
      }
    ]
  },
  {
    id: 'keizoku',
    label: '浸水継続時間\n(想定最大規模)',
    urls: [
      'https://disaportaldata.gsi.go.jp/raster/01_flood_l2_keizoku_data/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '浸水継続時間',
        colors: [
          { color: 'rgb(160, 210, 255)', value: '12時間未満' },
          { color: 'rgb(0, 65, 255)', value: '12時間〜1日未満' },
          { color: 'rgb(250, 245, 0)', value: '1日〜3日未満' },
          { color: 'rgb(255, 153, 0)', value: '3日〜1週間未満' },
          { color: 'rgb(255, 40, 0)', value: '1週間〜2週間未満' },
          { color: 'rgb(180, 0, 104)', value: '2週間〜4週間未満' },
          { color: 'rgb(96, 0, 96)', value: '4週間以上〜' }
        ]
      }
    ]
  },
  {
    id: 'kaokutoukai_hanran',
    label: '家屋倒壊等氾濫想定区域\n(氾濫流)',
    urls: [
      'https://disaportaldata.gsi.go.jp/raster/01_flood_l2_kaokutoukai_hanran_data/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '家屋倒壊等氾濫想定区域\n(氾濫流)',
        image: 'https://disaportal.gsi.go.jp/hazardmap/copyright/img/kaokutoukai_hanran.png'
      }
    ]
  },
  {
    id: 'kaokutoukai_kagan',
    label: '家屋倒壊等氾濫想定区域\n(河岸侵食)',
    urls: [
      'https://disaportaldata.gsi.go.jp/raster/01_flood_l2_kaokutoukai_kagan_data/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '家屋倒壊等氾濫想定区域\n(河岸侵食)',
        image:
          'https://disaportal.gsi.go.jp/hazardmap/copyright/img/kaokutoukai_kagan.png'
      }
    ]
  },
  {
    id: 'dosyasaigai_keikaikuiki',
    label: '土砂災害警戒区域',
    urls: [
      'https://disaportaldata.gsi.go.jp/raster/05_jisuberikeikaikuiki/{z}/{x}/{y}.png',
      'https://disaportaldata.gsi.go.jp/raster/05_dosekiryukeikaikuiki/{z}/{x}/{y}.png',
      'https://disaportaldata.gsi.go.jp/raster/05_kyukeishakeikaikuiki/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '特別警戒区域',
        colors: [
          { color: 'rgb(193, 76, 98)', value: '土石流' },
          { color: 'rgb(252, 104, 77)', value: '急傾斜地の崩壊' },
          { color: 'rgb(203, 76, 147)', value: '地滑り' }
        ]
      },
      {
        title: '警戒区域',
        colors: [
          { color: 'rgb(238, 216, 118)', value: '土石流' },
          { color: 'rgb(255, 237, 90)', value: '急傾斜地の崩壊' },
          { color: 'rgb(255, 183, 84)', value: '地滑り' }
        ]
      }
    ]
  },
  {
    id: 'lcmfc2',
    label: '治水地形分類図',
    urls: [
      'https://cyberjapandata.gsi.go.jp/xyz/lcmfc2/{z}/{x}/{y}.png'
    ],
    legends: []
  },
  {
    id: 'naisui',
    label: '内水ハザードマップ',
    urls: [
      'https://s3.ap-northeast-1.amazonaws.com/ctie.shizuoka.web/static/tile/naisui/{z}/{x}/{y}.png'
    ],
    legends: [
      {
        title: '想定される浸水深',
        colors: [
          { color: '#3F7EB1', value: '1.00〜2.00m 未満' },
          { color: '#9BC468', value: '0.45〜1.00m 未満' },
          { color: '#E7E384', value: '0.30〜0.45m 未満' },
          { color: '#FACAD6', value: '0.10〜0.30m 未満' },
          { color: '#FFFFFF', value: '0.10m 未満' }
        ]
      }
    ]
  },
  {
    id: 'SinsuiH26',
    label: '浸水実績H26.10',
    urls: [
      'https://s3.ap-northeast-1.amazonaws.com/ctie.shizuoka.web/static/tile/SinsuiH26/{z}/{x}/{y}.png'
    ],
    legends: []
  },
  {
    id: 'SinsuiR04',
    label: '浸水実績R4.9',
    urls: [
      'https://s3.ap-northeast-1.amazonaws.com/ctie.shizuoka.web/static/tile/SinsuiR04/{z}/{x}/{y}.png'
    ],
    legends: []
  },
]
